import { useLoaderData } from "react-router"
import React from "react"
import DraftPanel from "./panels/DraftPanel";
import ReviewPanel from "./panels/ReviewPanel";
import PendingPanel from "./panels/PendingPanel";
import CompletedPanel from "./panels/CompletedPanel";
import DiscardedPanel from "./panels/DiscardedPanel";


export const EsignEditApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ESignDetailFrontModel>();

  return <>
    {viewModel.details.lifeCycle.value === "draft" && <DraftPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle.value === "review" && <ReviewPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle.value === "pending" && <PendingPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle.value === "completed" && <CompletedPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle.value === "discarded" && <DiscardedPanel
      viewModel={viewModel}
    />}
  </>
}